import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";

const Home                   = lazy(() => import("@/pages/home"));
const Pricing                = lazy(() => import("@/pages/pricing"));
const CaptureLeads           = lazy(() => import("@/pages/capture-leads"));
const PrivacyPolicy          = lazy(() => import("@/pages/privacy-policy"));
const Terms                  = lazy(() => import("@/pages/terms"));
const Login                  = lazy(() => import("@/pages/login"));
const Signup                 = lazy(() => import("@/pages/signup"));
const ForgotPassword         = lazy(() => import("@/pages/forgot-password"));
const ResetPassword          = lazy(() => import("@/pages/reset-password"));
const AdminForgotPassword    = lazy(() => import("@/pages/admin-forgot-password"));
const AdminResetPassword     = lazy(() => import("@/pages/admin-reset-password"));
const ChatbotDetail          = lazy(() => import("@/pages/chatbot-detail"));
const OwnerDashboard         = lazy(() => import("@/pages/owner-dashboard"));
const AdminDashboard         = lazy(() => import("@/pages/admin-dashboard"));
const NotFound               = lazy(() => import("@/pages/not-found"));
const Tools                  = lazy(() => import("@/pages/tools"));
const ChatWithWebsite        = lazy(() => import("@/pages/chat-with-website"));
const ChatWithText           = lazy(() => import("@/pages/chat-with-text"));
const ChatWithPdf            = lazy(() => import("@/pages/chat-with-pdf"));
const ChatWithWord           = lazy(() => import("@/pages/chat-with-word"));
const ChatWithDocument       = lazy(() => import("@/pages/chat-with-document"));
const FaqGenerator           = lazy(() => import("@/pages/faq-generator"));
const LinkedInPostGenerator  = lazy(() => import("@/pages/linkedin-post-generator"));
const AiPromptOptimizer      = lazy(() => import("@/pages/ai-prompt-optimizer"));
const ChatbotForRestaurants  = lazy(() => import("@/pages/chatbot-for-restaurants"));
const ChatbotForEcommerce    = lazy(() => import("@/pages/chatbot-for-ecommerce"));
const ChatbotForRealEstate   = lazy(() => import("@/pages/chatbot-for-real-estate"));
const ChatbotForCoaches      = lazy(() => import("@/pages/chatbot-for-coaches"));
const ChatbotForHomeServices = lazy(() => import("@/pages/chatbot-for-home-services"));
const ChatbotForMedSpa       = lazy(() => import("@/pages/chatbot-for-med-spa"));
const ContactUs              = lazy(() => import("@/pages/contact"));
const ForAIAgents            = lazy(() => import("@/pages/ForAIAgents"));
const SelfDashboard          = lazy(() => import("@/pages/SelfDashboard"));
const Reporting              = lazy(() => import("@/pages/Reporting"));

function AdminRoute({ children }) {
  const token = localStorage.getItem("admin_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function OwnerRoute({ children }) {
  const { chatbotId } = useParams();
  const location = useLocation();
  const storedId = localStorage.getItem("owner_chatbot_id");
  if (!storedId || storedId !== chatbotId) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${returnTo}`} replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/capture-leads" element={<CaptureLeads />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/chat-with-website" element={<ChatWithWebsite />} />
          <Route path="/tools/chat-with-text" element={<ChatWithText />} />
          <Route path="/tools/chat-with-pdf" element={<ChatWithPdf />} />
          <Route path="/tools/chat-with-word" element={<ChatWithWord />} />
          <Route path="/tools/chat-with-document" element={<ChatWithDocument />} />
          <Route path="/tools/faq-generator" element={<FaqGenerator />} />
          <Route path="/tools/linkedin-post-generator" element={<LinkedInPostGenerator />} />
          <Route path="/tools/ai-prompt-optimizer" element={<AiPromptOptimizer />} />
          <Route path="/chatbot-for-restaurants" element={<ChatbotForRestaurants />} />
          <Route path="/chatbot-for-ecommerce" element={<ChatbotForEcommerce />} />
          <Route path="/chatbot-for-real-estate" element={<ChatbotForRealEstate />} />
          <Route path="/chatbot-for-coaches" element={<ChatbotForCoaches />} />
          <Route path="/chatbot-for-home-services" element={<ChatbotForHomeServices />} />
          <Route path="/chatbot-for-med-spa" element={<ChatbotForMedSpa />} />
          <Route path="/for-ai-agents" element={<ForAIAgents />} />
          <Route path="/self" element={<SelfDashboard />} />
          <Route path="/reporting" element={<Reporting />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin-login" element={<Navigate to="/login" replace />} />
          <Route path="/owner-login" element={<Navigate to="/login" replace />} />
          <Route path="/owner/:chatbotId" element={<OwnerRoute><OwnerDashboard /></OwnerRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/chatbots/:id" element={<AdminRoute><ChatbotDetail /></AdminRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
